<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">Which is the <b>primary</b> reason for your visit?</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col">
                <multiselect-list :options="selectedParts" @optionSelected="optionSelected"></multiselect-list>
            </div>
            <div class="col-md-1"></div>
        </div>
        <div class="row">
            <div class="col text-center mt-2">
                <button type="button" @click.prevent="submit()" class="btn btn-primary btn-lg mx-auto mt-2" style="width: 40%"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
            </div>
        </div>
    </div>
</template>

<script>
  import MultiselectList from '../../components/MultiselectList'
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'BodyParts',

    components: { MultiselectList },

    mixins: [ErrorsMixin, AnalyticsMixin],

    data () {
      return {
        isSaving: false,
        selectedCode: '',
        orthoReasonForVisit: {
          primaryBodyPartCode: ''
        },
        selectedParts: []
      }
    },

    computed: {
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.orthoReasonForVisit.primaryBodyPartCode) {
          this.addErrorForField('exception', 'You must select an option.')
        }

        return !this.hasErrors()
      },

      optionSelected (item) {
        this.clearAllErrors()

        for (const option of this.selectedParts) {
          option.selected = false
        }
        item.selected = true
        this.orthoReasonForVisit.primaryBodyPartCode = item.code
      },

      submit () {
        if (this.validate() !== true) {
          return
        }

        this.orthoReasonForVisit.bodyPartCodes = this.$store.selectedBodyParts
        this.isSaving = true
        api.put('/Patient/OrthoReasonForVisit', this.orthoReasonForVisit).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)
          this.$store.primaryBodyPart.code = this.orthoReasonForVisit.primaryBodyPartCode
          this.$store.primaryBodyPart.name = this.$store.bodyPartNames[this.orthoReasonForVisit.primaryBodyPartCode]
          this.$router.push('ortho-pain-type')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      loadData () {
        api.get('/Patient/OrthoReasonForVisit').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.orthoReasonForVisit = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            this.setFromApiErrorResponse(error)
          }
        })
      }
    },

    created () {
      this.selectedParts = this.$store.selectedBodyParts.map(code => {
        return {
          name: this.$store.bodyPartNames[code],
          selected: false,
          code
        }
      })
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
